document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('[data-recently-viewed]');
  if (!container) return;

  const wrapper = container.closest('.recently-viewed__wrapper');
  const prev = wrapper.querySelector('.recently-viewed__arrow--prev');
  const next = wrapper.querySelector('.recently-viewed__arrow--next');

  const maxItems = Number(container.dataset.maxItems) || 8;
  const itemsPerPageManual =
    Number(container.dataset.itemsPerPage) || 0;

  const key = 'recently_viewed_products';
  const handles = JSON.parse(localStorage.getItem(key)) || [];

  let currentPage = 0;

  /* =========================
     商品カードを追加
  ========================= */
  const addProducts = async () => {
  for (const handle of handles.slice(0, maxItems)) {
    try {
      const res = await fetch(`/products/${handle}?view=card`);

      // 404などはスキップ
      if (!res.ok) continue;

      const html = await res.text();

      // 一旦DOM化
      const temp = document.createElement('div');
      temp.innerHTML = html;

      // 正しいカードがあるか確認
      const card = temp.querySelector('.card');

      if (!card) {
  const index = handles.indexOf(handle);
  if (index > -1) {
    handles.splice(index, 1);
    localStorage.setItem(key, JSON.stringify(handles));
  }
  continue;
}


      const li = document.createElement('li');
      li.className = 'grid__item';
      li.appendChild(card);

      container.appendChild(li);

    } catch (e) {
      console.warn('recently viewed load error:', handle);
    }
  }
};


  /* =========================
     カード1枚の実寸幅
  ========================= */
  const getCardUnitWidth = () => {
    const card = container.querySelector('.grid__item');
    if (!card) return 0;

    const rect = card.getBoundingClientRect();
    const style = window.getComputedStyle(card);
    const marginRight = parseFloat(style.marginRight) || 0;

    return rect.width + marginRight;
  };

  /* =========================
     ページ情報を計算
  ========================= */
  const getPageInfo = () => {
    const unit = getCardUnitWidth();
    if (!unit) {
      return {
        unit: 0,
        visibleCount: 1,
        maxPage: 0
      };
    }

    const visibleCount = itemsPerPageManual > 0
      ? itemsPerPageManual
      : Math.floor(container.clientWidth / unit) || 1;

    const totalItems =
      container.querySelectorAll('.grid__item').length;

    const maxPage = Math.max(
      0,
      totalItems - visibleCount
    );

    return { unit, visibleCount, maxPage };
  };

  /* =========================
     指定ページへスクロール
  ========================= */
  const scrollToPage = (page) => {
    const { unit, maxPage } = getPageInfo();

    currentPage = Math.max(0, Math.min(page, maxPage));

    container.scrollTo({
      left: unit * currentPage,
      behavior: 'smooth'
    });

    updateArrowState();
  };

  /* =========================
     矢印クリック
  ========================= */
  prev.addEventListener('click', () => {
    scrollToPage(currentPage - 1);
  });

  next.addEventListener('click', () => {
    scrollToPage(currentPage + 1);
  });

  /* =========================
     矢印の有効・無効
  ========================= */
  const updateArrowState = () => {
    const { maxPage } = getPageInfo();

    prev.classList.toggle('is-disabled', currentPage <= 0);
    next.classList.toggle('is-disabled', currentPage >= maxPage);
  };

  /* =========================
     件数少 → 矢印非表示
  ========================= */
  const updateArrowsVisibility = () => {
    const needsScroll =
      container.scrollWidth > container.clientWidth + 5;

    prev.style.display = needsScroll ? '' : 'none';
    next.style.display = needsScroll ? '' : 'none';
  };

  /* =========================
     初期化
  ========================= */
  const init = async () => {
    await addProducts();

    // 初期状態を明示
    currentPage = 0;

    setTimeout(() => {
      updateArrowsVisibility();
      updateArrowState();
    }, 200);
  };

  init();

  /* =========================
     リサイズ対応
  ========================= */
  window.addEventListener('resize', () => {
    const { maxPage } = getPageInfo();

    // 表示枚数変更で currentPage がはみ出た場合の補正
    if (currentPage > maxPage) {
      currentPage = maxPage;
      scrollToPage(currentPage);
    }

    updateArrowsVisibility();
    updateArrowState();
  });
});
